//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import moment from 'moment'
import { merge } from 'lodash'
import { OpKind } from '@taquito/taquito'
import * as signalR from '@microsoft/signalr'
import SampleArtwork from '~/components/SampleArtwork.vue'
import HowToParticipate from '~/components/HowToParticipate.vue'
import CreatorTab from '~/components/CreatorTab.vue'
import MarketplaceTab from '~/components/MarketplaceTab.vue'
import HelpWalletDialog from '@/components/HelpWalletDialog.vue'
import AffiliatesTab from '~/components/AffiliatesTab.vue'
import SampleArtworkDialog from '~/components/SampleArtworkDialog.vue'
import TopUpDialog from '~/components/TopUpDialog.vue'
import CheckBrowser from '~/components/projects/CheckBrowser'
import Utils from '@/utils/global-utils'
import { steps } from '~/utils/tour.steps'
import CheckSupportedBrowser from '~/pages/sandbox/Helpers/CheckSupportedBrowser'
import SandboxTag from '~/components/projects/SandboxTag'
import DotError from '~/components/projects/DotError'
import ReportCollection from '~/components/projects/ReportCollection'
import CrowdsaleWidget from "~/components/projects/CrowdsaleWidget";

export default {
  name: 'ProjectDetails',
  components: {
    SampleArtwork,
    HelpWalletDialog,
    HowToParticipate,
    CreatorTab,
    MarketplaceTab,
    AffiliatesTab,
    SampleArtworkDialog,
    TopUpDialog,
    CheckBrowser,
    SandboxTag,
    DotError,
    ReportCollection,
    CrowdsaleWidget
  },

  async asyncData({ params, $axios, redirect, $cookies, route, $store }) {
    let project
    let isApproved = false
    const collaborators = []
    const royaltyShare = []
    try {
      project = await $axios.$get(
        `/api/projects/${params.id}?includeUser=true&includeSampleTokens=true&includeLayers=true`
      )

      isApproved = project.is_finished && project.approved

      if (project.collaborators) {
        for (const col in project.collaborators) {
          collaborators.push({
            wallet: col,
            royalty: project.collaborators[col] / 10,
          })
        }
      }

      if (project.royalty_share) {
        for (const col in project.royalty_share) {
          royaltyShare.push({
            wallet: col,
            royalty: project.royalty_share[col] / 10,
          })
        }
      }

      project.royalty = project.royalty / 10
    } catch (err) {
      return redirect('/error')
    }

    let referredBy = $cookies.get(`${params.id}-ref`)

    if (!referredBy) {
      referredBy = route.query.wallet

      // still nothing? fall back to artist wallet
      if (!referredBy) {
        referredBy = project.wallet
      }

      $cookies.set(`${params.id}-ref`, referredBy, {
        path: '/',
        maxAge: 60 * 60 * 24 * 7,
      })
    }

    const mobileSelect = [
      'Artwork Samples',
      'How to participate & rules',
      'Creator',
    ]
    const tabs = ['Artwork Samples', 'How to participate & rules', 'Creator']
    if (project.referral_percentage > 0) {
      tabs.push('ArtForge Smiths Program')
      mobileSelect.push('ArtForge Smiths Program')
    }

    const copyProject = JSON.parse(JSON.stringify(project))
    const copyCollaborators = JSON.parse(JSON.stringify(collaborators))
    const copyRoyaltyShare = JSON.parse(JSON.stringify(royaltyShare))

    const tourSteps = steps
    tourSteps[5].content = `This will display information about you as the creator. To update this information, please visit your <a target="_blank" href="/profile/${project.User.author_wallet}" style="color:white">profile page</a>`

    // get the default model
    return {
      seconds: 0,
      started: false,
      ended: false,
      status: '',
      statusMsg: '',
      socialMedia: [],
      tokens: project.SampleTokens,
      project,
      copyProject,
      copyCollaborators,
      copyRoyaltyShare,
      isApproved,
      palette: '',
      currentTab: 0,
      crowdsale: {},
      royaltyShare,
      collaborators,
      purchaseDialog: false,
      agree: false,
      tab: tabs[0],
      tabs,
      tourSteps,
      dropdownModel: tabs[0],
      items: tabs,
      referredBy,
      referredByAlias: null,
      referredByLocked: false,
      mobileSelect,
    }
  },
  data() {
    return {
      amountToPurchase: 1,
      crowdsaleBigMapId: null,
      whitelistBigMapId: null,
      isWhitelisted: false,
      loading: false,
      minting: false,
      confirmation: true,
      mintError: false,
      errorDialog: false,
      dialog: false,
      projBarHeight: 0,
      socket: null,
      minDate: moment().add(1, 'hour').toISOString(),
      setEndAt: false,
      isLoading: false,
      isLoadingPublish: false,
      isApproved: false,
      lastModified: null,
      collaborators: [],
      royaltyShare: [],
      confirmDialog: false,
      saveAndPublish: false,
      supportedBrowser: null,
      menu: {
        name: {
          shown: false
        },
        description: {
          shown: false
        },
        tokens_count: {
          shown: false
        },
        token_price: {
          shown: false
        }
      },
      vueTourCallbacks: {
        onSkip: this.tourHide,
        onFinish: this.tourHide,
        onStop: this.tourHide,
        onPreviousStep: this.vueTourPreviousStep,
        onNextStep: this.vueTourNextStep
      },
      errors: null,
      files: {
        avatar: {},
        hero: {},
        placeholder: {},
      },
      step2Rules: {
        datePicker: [(value) => !!value || 'Required.'],
      },
      step3Rules: {
        token_symbol: [
          (v) => v !== null || 'Token symbol is required.',
          (v) => !!v || 'Token symbol is required.',
          (v) =>
            (v && v.length >= 2 && v.length <= 5) ||
            'Token symbol must be between 2 to 5 characters only.',
        ],
        tokens_count: [
          (v) => v > 0 || 'Please input a valid number of tokens.',
        ],
        token_price: [(v) => v > 0 || 'Please input a valid amount.'],
        trait_name: [
          (v) => (v !== null && v !== '') || 'Trait name is required.',
        ],
      },
      step4Rules: {
        walletAddress: [(value) => !!value || 'Required.'],
      },
      customToolbar: [['bold', 'italic', 'underline', 'strike'], ['clean']],
    }
  },
  head() {
    const title = `${this.project.name} by ${this.project.User.username} on ArtForge`
    const url = `https://artforge.io/collections/${this.project.slug}`
    const desc = this.project.description.replace(/<\/?[^>]+>/ig, " ")
    return {
      title,
      meta: [
        {
          hid: 'description',
          name: 'description',
          content: desc,
        },
        { hid: 'og:url', property: 'og:url', content: url },
        {
          hid: 'og:title',
          property: 'og:title',
          content: title,
        },
        {
          hid: 'og:description',
          property: 'og:description',
          content: desc,
        },
        {
          hid: 'og:image',
          property: 'og:image',
          content: this.project.hero,
        },

        // Twitter
        {
          hid: 'twitter:card',
          property: 'twitter:card',
          content: 'summary_large_image',
        },
        {
          hid: 'twitter:url',
          property: 'twitter:url',
          content: url,
        },
        {
          hid: 'twitter:title',
          property: 'twitter:title',
          content: title,
        },
        {
          hid: 'twitter:description',
          property: 'twitter:description',
          content: desc,
        },
        {
          hid: 'twitter:image',
          property: 'twitter:image',
          content: this.project.hero,
        },
      ],
    }
  },
  computed: {
    isPreview() {
      return this.$route.query.type === 'preview'
    },
    sanitizeDescription() {
      return this.$sanitize(this.project.description)
    },
    lastSaveHumanRead() {
      if (this.lastModified === null) return ''

      let message = 'Draft saved : '

      if (this.lastModified / 60 > 1) {
        message += parseInt(this.lastModified / 60) + ' minute'
        if (this.lastModified / 60 >= 2) message += 's'
      } else {
        message += this.lastModified + ' seconds'
      }

      message += ' ago'

      return message
    },
    localEnd() {
      return moment(this.project.end_at).toLocaleString()
    },
    maxAmount() {
      if (this.project.tokens_per_wallet > 0) {
        return this.project.tokens_per_wallet
      }
      return 10
    },
    endDate() {
      const e = moment(this.project.end_at)
      return e.isValid() ? e : null
    },
    startDate() {
      return moment(this.project.start_at)
    },
    isSoldOut() {
      return this.project.tokens_count === this.project.tokens_minted
    },
    userAddress() {
      return this.$store.getters.userAddress
    },
    userAlias() {
      return this.$store.state.userAlias
    },
    customViewport() {
      return this.$vuetify.breakpoint.xs ? 'mb-n8' : ''
    },
    balance() {
      return this.$store.getters.balance
    },
    xtzMissing() {
      const amt =
        this.project.token_price * 1000000 * this.amountToPurchase * 1.1
      if (amt < this.balance) {
        return 0
      }
      return amt - this.balance
    },
    revealDelay() {
      return Utils.number2words(this.project.reveal_delay)
    },
    editDisabled() {
      if (this.$route.query.type === 'preview') {
        return true
      }

      if (this.$store.getters.isAuthenticated) {
        if (
          this.$store.getters.getUserInfo.id === this.project.user_id &&
          !this.project.approved &&
          !this.project.is_finished
        ) {
          return false
        }
      }

      return true
    },
    collapsed() {
      return this.$store.state.prefs.crowdsalesSetting
    },
  },
  watch: {
    userAddress(value) {
      // if (value && this.crowdsale.whitelist_enabled) {
      //   this.checkWhitelistStatus()
      // }
    },
    purchaseDialog(v) {
      if (v) {
        if (!this.minting) {
          this.$store.dispatch('loadBalance', this.userAddress)
          this.confirmation = false
          this.agree = false
          if (this.project.referral_contract) {
            this.checkStatus()
          }
        }
      }
    },
  },
  mounted() {
    if (this.project.crowdsale_id) {
      const { statuses } = this.$config
      // await this.getCrowdsale()
      // if (this.userAddress) await this.checkWhitelistStatus()
      if (this.project.status === statuses.ongoing) {
        // this.pollProjectStatus()
        this.initTzktSocket()
      }
    }

    setTimeout(() => {
      this.projectBarOffset()
    }, 50)

    if (this.project.referral_contract) {
      this.checkStatus()
    }

    if (!this.editDisabled) {
      setTimeout(() => {
        if (this.$store.state.prefs.vueTour) {
          this.$tours.myTour.start(this.$store.state.prefs.vueTourStep)
        }
      }, 1000)

      setInterval(() => {
        this.autosave()
      }, 10000)
    }

    this.supportedBrowser = CheckSupportedBrowser()
  },

  deactivated() {
    console.log('deactivated')
  },
  activated() {
    console.log('activated')
  },
  unmounted() {
    console.log('unmounted')
  },
  methods: {
    startTour() {
      console.log(this.$store.state.prefs.vueTourStep)
      if (this.$store.state.prefs.vueTourStep === 0) {
        window.scrollTo(0, 0)
      }
      this.$store.dispatch('setPref', {
        pref: `vueTour`,
        value: true,
      })
      this.$tours.myTour.start(this.$store.state.prefs.vueTourStep)
    },
    tourHide() {
      this.$store.dispatch('setPref', {
        pref: `vueTour`,
        value: false,
      })
    },
    vueTourPreviousStep() {
      this.$store.dispatch('setPref', {
        pref: `vueTourStep`,
        value: this.$store.state.prefs.vueTourStep - 1,
      })
    },
    vueTourNextStep() {
      this.$store.dispatch('setPref', {
        pref: `vueTourStep`,
        value: this.$store.state.prefs.vueTourStep +1,
      })
    },
    setCollapsed(collapsed) {
      this.$store.dispatch('setPref', {
        pref: `crowdsalesSetting`,
        value: collapsed,
      })
    },
    addCollaborator() {
      if (this.collaborators.length >= 10) return

      this.collaborators.push({
        wallet: '',
        royalty: '',
      })
    },
    addRoyaltyShare() {
      if (this.royaltyShare.length >= 10) return

      this.royaltyShare.push({
        wallet: '',
        royalty: '',
      })
    },
    convertDate(date) {
      if (typeof date === 'string') return moment(date)
      return moment(this.minDate)
    },
    getStartDateTime(dateTime) {
      this.project.start_at = dateTime
      this.endMinDate = moment(dateTime).add(1, 'days').format('YYYY-MM-DD')
    },
    getEndDateTime(dateTime) {
      this.duration = moment(this.endDate).diff(this.startDate, 'days')
      this.project.end_at = dateTime
    },
    async initTzktSocket() {
      const { tzktPrefix } = this.$config
      const tzktSocket = new signalR.HubConnectionBuilder()
        .withUrl(`https://api${tzktPrefix}.tzkt.io/v1/events`)
        .build()
      await tzktSocket.start()

      await tzktSocket.invoke('SubscribeToOperations', {
        address: this.project.fa2_address,
        types: 'transaction',
      })

      tzktSocket.on('operations', async (msg) => {
        if (msg.type === 1) {
          await Promise.all(
            msg.data.map((tx) => {
              if (
                tx.status === 'applied' &&
                tx.parameter &&
                tx.parameter.entrypoint === 'mint'
              ) {
                // console.log(tx)
                this.project.tokens_minted++
                if (this.project.tokens_count < this.project.tokens_minted) {
                  this.project.tokens_count = this.project.tokens_minted
                }
                this.setProjectStatus()
              }
              return tx
            })
          )
        }
      })
    },
    setProjectStatus() {
      if (!this.isApproved) {
        this.project.status = 'draft'
      } else if (this.project.tokens_minted === this.project.tokens_count) {
        this.project.status = 'sold-out'
      } else {
        const start = moment(this.project.start_at)
        const now = moment()
        const end = moment(this.project.end_at)
        if (start.isAfter(now)) {
          this.project.status = 'scheduled'
        } else if (!end.isValid() || (end.isValid() && now.isBefore(end))) {
          this.project.status = 'ongoing'
        } else {
          this.project.status = 'ended'
        }
      }
    },
    loadTopUpModule() {
      this.$refs.topUpDialog.handleOpen(this.xtzMissing / 1000000, this.balance)
    },
    projectBarOffset() {
      if (this.$refs.projectBar) {
        const height = this.$refs.projectBar.$el.clientHeight
        this.projBarHeight = height / 2
      }
    },
    openHelpWallet() {
      this.purchaseDialog = false
      this.$refs.helpWalletDialog.handleOpen()
    },
    openSampleArtwork() {
      this.$refs.sampleArtworkDialog.handleOpen()
    },
    openCreator() {
      this.$refs.creatorDialog.handleOpen()
    },
    openFAQ() {
      this.$refs.faqDialog.handleOpen()
    },
    async getCrowdsaleStorage() {
      const { tzktPrefix } = this.$config
      const storageResp = await this.$axios(
        `https://api${tzktPrefix}.tzkt.io/v1/contracts/${this.project.crowdsale_address}/storage`
      )
      return storageResp?.data
    },
    async getBigMapIDs() {
      if (this.crowdsaleBigMapId === null || this.whitelistBigMapId === null) {
        const s = await this.getCrowdsaleStorage()
        this.crowdsaleBigMapId = s.crowdsales
        this.whitelistBigMapId = s.whitelist
      }
    },
    async getCrowdsale() {
      const { tzktPrefix } = this.$config
      await this.getBigMapIDs()
      const saleResp = await this.$axios(
        `https://api${tzktPrefix}.tzkt.io/v1/bigmaps/${this.crowdsaleBigMapId}/keys/${this.project.crowdsale_id}`
      )
      if (saleResp && saleResp?.data) this.crowdsale = saleResp?.data.value
    },
    async checkWhitelistStatus() {
      const { tzktPrefix } = this.$config
      await this.getBigMapIDs()
      const resp = await this.$axios(
        `https://api${tzktPrefix}.tzkt.io/v1/bigmaps/${this.whitelistBigMapId}/keys/${this.userAddress}`
      )
      if (resp && resp?.data) this.whitelisted = resp?.data.value
      this.isWhitelisted = resp?.data?.active === true
    },
    async pollWhitelistStatus() {
      await this.checkWhitelistStatus()
      if (this.isWhitelisted === false) {
        await new Promise((resolve) => setTimeout(resolve, 5000))
        await this.pollWhitelistStatus()
      }
    },
    async loadProject() {
      const id = this.$route.params.id
      if (id) {
        const resp = await this.$store.dispatch('projects/loadProject', id)
        merge(this.project, resp.data)
      }
    },
    async pollProjectStatus() {
      await this.loadProject()
      this.projectBarOffset()
      const { statuses } = this.$config
      if (this.project.status === statuses.ongoing && this.$route?.params?.id) {
        console.log('polling project', this.project)
        await new Promise((resolve) => setTimeout(resolve, 15000))
        await this.pollProjectStatus()
      }
    },
    async isValidReferredBy() {
      try {
        const { tzktPrefix } = this.$config
        const storageResp = await this.$axios(
          `https://api${tzktPrefix}.tzkt.io/v1/contracts/${this.project.referral_contract}/storage?path=referrals`
        )
        const bmId = storageResp?.data
        const resp = await this.$axios(
          `https://api${tzktPrefix}.tzkt.io/v1/bigmaps/${bmId}/keys/${this.referredBy}`
        )
        return resp && resp?.data
      } catch (err) {
        return false
      }
    },
    async mintToken() {
      try {
        this.confirmation = false
        this.mintError = false
        this.loading = true
        this.minting = true

        const transactions = []

        // set referred by if this project supports affiliate marketing
        if (this.project.referral_contract) {
          // const match = this.referredBy.match(/[A-Za-z0-9_-]+/)
          if (
            !this.referredBy ||
            this.referredBy.length < 4 ||
            this.referredBy.length > 36
          ) {
            this.loading = false
            this.$store.dispatch('addSnackbar', {
              text: `Your invitation seems to be invalid. Please use a valid invitation to proceed.`,
              type: 'error',
            })
            return
          }
          // convert tez domains..
          const match = this.referredBy.match(/tz[A-Za-z0-9_-]{34}/)
          if (!match) {
            const addr = await this.$globals.resolveNameToAddress(
              this.referredBy
            )
            if (!addr) {
              this.loading = false
              this.$store.dispatch('addSnackbar', {
                text: `Your invitation seems to be invalid. Please use a valid invitation to proceed.`,
                type: 'error',
              })
              return
            }
            this.referredByAlias = this.referredBy
            this.referredBy = addr
          }
          const ref = await this.$globals.tezos.wallet.at(
            this.project.referral_contract
          )
          const isValid = await this.isValidReferredBy()
          if (!isValid) {
            this.loading = false
            this.$store.dispatch('addSnackbar', {
              text: `Your invitation seems to be invalid. Please use a valid invitation to proceed.`,
              type: 'error',
            })
            return
          }
          transactions.push({
            kind: OpKind.TRANSACTION,
            ...ref.methods.set_referred_by(this.referredBy).toTransferParams(),
          })
        }

        const opts = {}
        opts.amount = this.project.token_price * 1000000 * this.amountToPurchase
        opts.mutez = true
        const crowdsales = await this.$globals.tezos.wallet.at(
          this.project.crowdsale_address
        )
        transactions.push({
          kind: OpKind.TRANSACTION,
          ...crowdsales.methods
            .mint(this.amountToPurchase, this.project.crowdsale_id)
            .toTransferParams(),
          ...opts,
        })

        const batch = await this.$globals.tezos.wallet.batch(transactions)
        const op = await batch.send()
        await op.confirmation(1)
        this.loading = false
        this.minting = false
        this.confirmation = true
        this.referredByLocked = true
        if (!this.purchaseDialog) {
          const msg = `You successfully minted ${this.amountToPurchase}
                          ${this.project.name} token${
            this.amountToPurchase > 1 ? 's' : ''
          }
                          for ${
                            this.amountToPurchase * this.project.token_price
                          } XTZ
                          (Tezos). Minted tokens are already in your wallet and
                          artwork will be revealed in approximately
                          ${this.project.reveal_delay} hour${
            this.project.reveal_delay > 1 ? 's' : ''
          }.`
          this.$store.dispatch('addSnackbar', { text: msg, timeout: 15000 })
        }
        // const resp = await this.$store.dispatch(
        //   'projects/loadProject',
        //   this.$route.params.id
        // )
        // merge(this.project, resp.data)
      } catch (e) {
        this.mintError =
          'The transaction was invalid. Please try again later. (You can try disconnecting and reconnecting your wallet.)'
        if (e.data) {
          const errJson = JSON.stringify(e.data)
          if (errJson.includes('MINTS_MAXED')) {
            this.mintError =
              'You have minted the maximum amount of tokens for this project'
          }
        } else if (e.description) {
          this.mintError = e.description
          if (e?.message?.includes('ABORTED_ERROR')) {
            this.mintError =
              'Action aborted. Please reconnect your wallet and try again'
            this.disconnectWallet()
          }
        }
        this.loading = false
        this.minting = false
        this.errorDialog = true
        console.error('Unable to claim token', e)
      }
    },
    setStatus() {
      const { statuses } = this.$config
      if (this.project.status === statuses.draft) {
        return 'Start Date'
      } else if (this.project.status === statuses.scheduled) {
        return 'Starting in'
      } else if (
        this.project.status === statuses.ongoing &&
        this.project.end_at !== null
      ) {
        return 'Ending'
      } else if (this.project.status === statuses.ongoing) {
        return 'Ongoing'
      } else {
        return 'Ended'
      }
    },
    cardBackground(status) {
      const { statuses } = this.$config
      return {
        'nfty-feature-project-footer': [
          statuses.scheduled,
          statuses.draft,
        ].includes(status),
        black: status === statuses.ongoing,
        white: [statuses.ended, statuses.sold].includes(status),
        'black--text': [statuses.ended, statuses.sold].includes(status),
      }
    },
    formatDate(date, format) {
      return moment(date).format(format)
    },
    async connectWallet() {
      this.loading = true

      try {
        const userAddress = await this.$globals.connectWallet()
        const userAlias = await this.$globals.resolveAddressToName(userAddress)
        this.$store.commit('INIT_USER_WALLET', {
          wallet: userAddress,
          alias: userAlias,
        })
        this.$store.dispatch('logTerms', {
          wallet: userAddress,
          version: this.$config.termsVersion,
        })
        this.$store.dispatch('loadBalance', userAddress)
        this.loading = false
        if (this.project.referral_contract) {
          this.checkStatus()
        }
      } catch (e) {
        console.error('Unable to connect wallet', e)
        this.loading = false
      }
    },
    async disconnectWallet() {
      await this.$globals.disconnectWallet()
      this.$store.commit('INIT_USER_WALLET', { wallet: null, alias: null })
    },
    async checkStatus() {
      this.loading = true
      try {
        const { tzktPrefix } = this.$config
        const storageResp = await this.$axios(
          `https://api${tzktPrefix}.tzkt.io/v1/contracts/${this.project.referral_contract}/storage?path=referrals`
        )
        const bmId = storageResp?.data
        const resp = await this.$axios(
          `https://api${tzktPrefix}.tzkt.io/v1/bigmaps/${bmId}/keys/${this.userAddress}`
        )
        if (resp?.data) {
          // console.log('checkStatus', resp.data)
          this.referredBy = resp?.data?.value?.referred_by
          this.referredByLocked = true
          this.referredByAlias = await this.$globals.resolveAddressToName(
            this.referredBy
          )
        }
        this.loading = false
      } catch (err) {
        this.loading = false
      }
    },
    autosave(check = true) {

      if (
        check &&
        (JSON.stringify(this.project) !== JSON.stringify(this.copyProject) ||
          JSON.stringify(this.collaborators) !==
            JSON.stringify(this.copyCollaborators) ||
          JSON.stringify(this.royaltyShare) !==
            JSON.stringify(this.copyRoyaltyShare))
      ) {
        document.getElementById('saveButton').click()
      } else if (!check) {
        document.getElementById('saveButton').click()
      }
    },
    publish() {
      this.confirmDialog = false
      this.saveAndPublish = true
      document.getElementById('saveButton').click()
    },
    async uploadImage(index, element) {
      const formData = new FormData()
      formData.append(index, element)

      await this.save(formData)
    },
    async saveProject(event) {
      event.preventDefault()

      this.isLoadingPublish = true

      const formData = new FormData(event.target)

      if (this.collaborators.length > 0) {
        formData.append('collaborators', JSON.stringify(this.collaborators))
      }

      if (this.royaltyShare.length > 0) {
        formData.append('royalty_share', JSON.stringify(this.royaltyShare))
      }

      formData.set('start_at', moment.utc(this.project.start_at).toISOString())

      if (this.saveAndPublish) {
        this.errors = null

        formData.append('is_finished', 1)
        formData.append('approved', 1)
        formData.append(
          'service_agreement_version',
          this.$config.serviceAgreementVersion
        )
      }

      await this.save(formData)
    },
    async save(formData) {
      try {
        const result = await this.$axios({
          method: 'PUT',
          url: `/api/projects/${this.project.id}`,
          data: formData,
          headers: {
            'Content-Type': 'multipart/form-data',
            Authorization: `Bearer ${this.$store.state.token}`,
          },
        })

        this.lastModified = 0

        if (this.interval !== null) {
          clearInterval(this.interval)
        }

        this.interval = setInterval(() => {
          this.lastModified += 15
        }, 15000)

        this.project.avatar = result.data.avatar
        this.project.hero = result.data.hero
        this.project.placeholder = result.data.placeholder

        this.copyProject = JSON.parse(JSON.stringify(this.project))
        this.copyCollaborators = JSON.parse(JSON.stringify(this.collaborators))
        this.copyRoyaltyShare = JSON.parse(JSON.stringify(this.royaltyShare))

        this.isApproved = result.data.is_finished && result.data.approved

        if (result.data.is_finished && result.data.approved) {
          location.reload();
        } else {
          /* await this.$router.push({
            path: '/collections/' + result.data.slug,
          }) */
        }
      } catch (err) {
        if (err.response.data.errors) {
          this.errors = err.response.data.errors
        }
      } finally {
        this.saveAndPublish = false
        this.isLoadingPublish = false
      }
    },
    diffDate(date) {
      return this.$route.query.type === 'preview' && moment(date).diff() > 0
    }
  },
}
